// import config from '../config';
import { AuthenticationResult } from '@/types/authenticationResult'

type SamlLogInHttp = () => Promise<{ idp_url: string, saml_payload: string }>
type Saml2LoginHttpFromCustomPayloadProvider = (customUrl: string) => Promise<{ idpURL: string, samlPayload: string }>
type RedirectToRetrieveToken = (data: { idpUrl: string, samlPayload: string }) => Promise<void>

export const samlLogin = (saml2LoginHttp: SamlLogInHttp, redirectToSamlProvider: RedirectToRetrieveToken, saml2LoginHttpFromCustomPayloadProvider: Saml2LoginHttpFromCustomPayloadProvider) =>
  async (customProviderUrl?: string) => {
    let idpUrl, samlPayload
    if (customProviderUrl) {
      const loginResponse = await saml2LoginHttpFromCustomPayloadProvider(customProviderUrl)
      idpUrl = loginResponse.idpURL
      samlPayload = loginResponse.samlPayload
    } else {
      const loginResponse = await saml2LoginHttp()
      idpUrl = loginResponse.idp_url
      samlPayload = loginResponse.saml_payload
    }
    redirectToSamlProvider({ idpUrl, samlPayload })
  }
